import _ from 'lodash'
import SITE_HEADER_CONFIG from './config'
import SITE_GAP from '../site-gap'

class SiteHeaderClass {
    constructor() {
        this.DOM = {
            header: SITE_HEADER_CONFIG.header,
            nav: SITE_HEADER_CONFIG.nav,
            hamburger: SITE_HEADER_CONFIG.hamburger,
            mobileBg: SITE_HEADER_CONFIG.mobileBg
        }
        
        this.state = false
        this.init()
        window.innerWidth <= 1024 ? this._gap() : null
    }

    init() {
        this._listeners()
        console.log( this )
    }

    _listeners() {
        this.DOM.hamburger.addEventListener( 'click', this._state.bind( this ) )
        this.DOM.mobileBg.addEventListener( 'click', this._state.bind( this ) )
    }

    _gap() {
        this.DOM.nav.style.height = `${ window.innerHeight - SITE_GAP.gap }px`
    }

    _state() {
        this.state = !this.state
        this.state ? this._open() : this._close()
    }

    _open() {
        _.addClass( document.documentElement, 'nav--expanded' )
    }

    _close() {
        _.removeClass( document.documentElement, 'nav--expanded' )
    }
}

const SITE_HEADER = new SiteHeaderClass()
export default SITE_HEADER